import apiClient from '@/clients/apiClient';
import { saveAs } from 'file-saver';

export const createCorporate = (data) =>
  apiClient.post('corporate-profiles', data);

export const getCorporateList = (
  page = 1,
  pageSize = 10,
  search = '',
  sortBy = '',
  orderBy = '',
  status = ''
) =>
  apiClient.get(
    `corporate-profiles?Page=${page}&PageSize=${pageSize}&Search=${search}&Status=${status}&Sort.Sort_By=${sortBy}&Sort.Order_By=${orderBy}`
  );

export const getCorporateStatusCounts = () =>
  apiClient.get('corporate-profiles/entities/count');

export const getCorporateProfile = (id) =>
  apiClient.get(`corporate-profiles/${id}`);

export const getCorporateVendors = (
  id,
  page = 1,
  pageSize = 10,
  search = '',
  sortBy = '',
  orderBy = ''
) =>
  apiClient.get(
    `corporate-profiles/${id}/vendors?Page=${page}&PageSize=${pageSize}&Search=${search}&Sort.Sort_By=${sortBy}&Sort.Order_By=${orderBy}`
  );

export const getCorporateFacilities = (
  id,
  page = 1,
  pageSize = 10,
  search = '',
  sortBy = '',
  orderBy = ''
) =>
  apiClient.get(
    `corporate-profiles/${id}/facilities?Page=${page}&PageSize=${pageSize}&Search=${search}&Sort.Sort_By=${sortBy}&Sort.Order_By=${orderBy}`
  );

export const getCorporateDocuments = (
  id,
  page = 1,
  pageSize = 10,
  search = '',
  sortBy = '',
  orderBy = ''
) =>
  apiClient.get(
    `corporate-profiles/${id}/documents?Page=${page}&PageSize=${pageSize}&Search=${search}&Sort.Sort_By=${sortBy}&Sort.Order_By=${orderBy}`
  );
export const editCorporate = (data, id) =>
  apiClient.put(`corporate-profiles/${id}`, data);
export const getCorporateOverview = (id) =>
  apiClient.get(`corporate-profiles/${id}/overview`);
export const verifyCorporate = (id) =>
  apiClient.post(`corporate-profiles/${id}/verify`, {});
export const getAllVerifiedCorporate = () =>
  apiClient.get(`corporate-profiles/verified`);
export const getUnVerifiedCorporate = () =>
  apiClient.get(`corporate-profiles/unverified`);
export const getSimilarUnVerifiedCorporate = (verifiedProfileId) =>
  apiClient.get(`corporate-profiles/similar-unverified/${verifiedProfileId}`);
export const mergeCorporate = (verifiedProfileId, unverifiedProfileIds) =>
  apiClient.post('corporate-profiles/merge', {
    verifiedProfileId,
    unverifiedProfileIds,
  });
export const getSimilarVerifiedCorporate = (
  unverifiedProfileId,
  similarityThreshold
) =>
  apiClient.get(
    `corporate-profiles/similar-verified/${unverifiedProfileId}?similarityThreshold=${similarityThreshold}`
  );

export const exportCorporateList = (
  type,
  search = '',
  sortBy = '',
  orderBy = '',
  ids = [],
  status = ''
) => {
  const params = new URLSearchParams({
    Search: search,
    Status: status,
    'Sort.Sort_By': sortBy,
    'Sort.Order_By': orderBy,
  });

  if (ids && ids.length > 0) {
    ids.forEach((id) => {
      params.append('ids', id);
    });
  }

  return apiClient
    .get(`corporate-profiles/export/${type}?${params.toString()}`, {
      responseType: 'blob',
    })
    .then((response) => {
      saveAs(response.data, `corporates.${type}`);
    });
};
